import React from 'react'
import {
  Container,
  FormLabel,
  FormDashboardInput as FormInput,
  FormDashboardTextarea,
  Button,
  FormRow
} from '../../../components'
import { useViewport } from '../../../utils'
import khub from '../../../database/khub.json'
import { useInternationalization } from '../../../features/i18n';
const { email, whatsapp, whatsapp_link, address } = khub;
const finalEmail = email ? email : 'k-hub@peacegen.id'

const label = {
  formTitle: {
    en: 'Send Us a Message',
    id: 'Kirim pesan kepada kami'
  },
  companyInstitution: {
    en: 'Company/Institution',
    id: 'Perusahaan/Institusi'
  },
  message: {
    en: 'Messages',
    id: 'Pesan'
  },
  messagePlaceholder: {
    en: 'Your Messages',
    id: 'Pesan Anda'
  },
  getInTouch: {
    en: 'Get in Touch',
    id: 'Berhubungan'
  }
}

const MainContent = () => {
  const { isMobile } = useViewport()
  const { translate, language } = useInternationalization()

  return (
    <Container>
      <div className="pt-8 lg:pt-20 pb-16 lg:pb-24 flex flex-wrap -mx-4">
        <div className="w-full md:w-8/12 lg:w-6/12 px-4 lg:ml-auto">
          <h2 className="font-bold font-primary text-lg mb-4">
            {label.formTitle[language.name]}
          </h2>
          <form className="lg:mr-24">
            <FormRow>
            <FormLabel>{translate('AUTH', 'full_name')}</FormLabel>
              <FormInput className="w-full" />
            </FormRow>

            <FormRow>
              <FormLabel>{label.companyInstitution[language.name]}</FormLabel>
              <FormInput className="w-full" />
            </FormRow>

            <div className="flex flex-wrap -mx-4">
              <div className="w-full md:w-6/12 px-4">
                <FormRow>
                  <FormLabel>{translate('AUTH', 'email')}</FormLabel>
                  <FormInput className="w-full" />
                </FormRow>
              </div>
              <div className="w-full md:w-6/12 px-4">
                <FormRow>
                  <FormLabel>{translate('GENERAL', 'phone')}</FormLabel>
                  <FormInput className="w-full" />
                </FormRow>
              </div>
            </div>

            <FormRow>
              <FormLabel>{label.message[language.name]}</FormLabel>
              <FormDashboardTextarea className="w-full" rows={5} placeholder={label.messagePlaceholder[language.name]} />
            </FormRow>

            <div className="flex flex-wrap -mx-4">
              <div className="w-full md:w-6/12 px-4">
                <Button thin={isMobile}>{translate('GENERAL', 'submit')}</Button>
              </div>
            </div>
          </form>
        </div>

        <div className="w-full md:w-4/12 lg:w-3/12 px-4 lg:mr-auto mt-10 md:mt-0">
          <h2 className="font-bold font-primary text-lg mb-4">{label.getInTouch[language.name]}</h2>
          <div className="text-sm mb-5 lg:mb-8">
            <h3 className="font-semibold font-primary mb-2">{translate('GENERAL', 'location')}</h3>
            {
              address ? <div dangerouslySetInnerHTML={{__html: address}}/> : (
                <p className="text-gray-444">Default Address <br/>
                Jalan Daan Mogot No.63 Tj. Duren Utara<br/>
                Kec. Grogol petamburan, <br/>
                Daerah Khusus Ibukota Jakarta 11470</p>
              )
            }
          </div>

          <div className="text-sm lg:mb-8">
            <h3 className="font-semibold font-primary mb-2">{translate('GENERAL', 'phone')} &amp; {translate('AUTH', 'email')}</h3>
            <p className="text-gray-444">
              {
                whatsapp_link && whatsapp ? (
                  <a href={whatsapp_link} target="_blank" rel="noopener noreferrer">
                    {whatsapp}
                  </a>
                ) : (
                  whatsapp ? whatsapp : '+6222 7323101'
                )
              }
              <br/>
              <a className="text-primary underline" href={`mailto:${finalEmail}`}>
                {finalEmail}
              </a>
            </p>
          </div>

        </div>
      </div>
    </Container>
  )
}

export { MainContent }
